import { isFriday, isThursday, isWednesday, setHours, startOfHour } from 'date-fns'
import { zonedTimeToUtc } from 'date-fns-tz'

const deliveryLocationsByCountry = {
  US: [
    {
      location: 'CT',
      shippingRegions: [
        'AA',
        'AE',
        'AP',
        'CT',
        'DC',
        'DE',
        'MA',
        'MD',
        'ME',
        'MI',
        'NH',
        'NJ',
        'NY',
        'PA',
        'RI',
        'VT',
      ],
    },
    {
      location: 'FL',
      shippingRegions: [
        'AL',
        'AR',
        'FL',
        'GA',
        'IA',
        'IL',
        'IN',
        'KS',
        'KY',
        'LA',
        'MO',
        'MS',
        'NC',
        'OH',
        'OK',
        'PR',
        'SC',
        'TN',
        'TX',
        'VA',
        'WI',
        'WV',
      ],
    },
    {
      location: 'NV',
      shippingRegions: ['AK', 'AZ', 'CA', 'HI', 'NM', 'NV', 'UT'],
    },
    {
      location: 'MT',
      shippingRegions: ['CO', 'ID', 'MN', 'MT', 'ND', 'NE', 'OR', 'SD', 'WA', 'WY'],
    },
  ],
}

const deliveryLocation = (address) => {
  const defaultLocation = 'CT'

  const shippingCountryCode = address.country.code
  const deliveryLocations = deliveryLocationsByCountry[shippingCountryCode]

  const regionCode = address.region.code

  if (!deliveryLocations || !regionCode) {
    return defaultLocation
  }

  const deliveryLocationWithRegion = deliveryLocations.find(({ shippingRegions }) =>
    shippingRegions.includes(regionCode),
  )
  return deliveryLocationWithRegion?.location || defaultLocation
}

const deliveryLocationTimezone = (address) => {
  const location = deliveryLocation(address)

  switch (location) {
    case 'MT':
      return 'America/Denver'
    case 'NV':
      return 'America/Los_Angeles'
    default:
      return 'America/New_York'
  }
}

export const showHoldUntilMonday = ({ address, items }) => {
  const hasHeatSensitive = items.some((item) => item.item_attributes.heat_sensitive)
  if (!hasHeatSensitive) {
    return false
  }

  const currentDate = new Date()
  // define cut-off date/time using local timezone initially
  const cutOffDateLocal = startOfHour(setHours(currentDate, 15))
  // apply delivery location's timezone offset for actual cut-off date/time
  const cutOffDate = zonedTimeToUtc(cutOffDateLocal, deliveryLocationTimezone(address))
  return (
    (isWednesday(currentDate) && currentDate > cutOffDate) ||
    isThursday(currentDate) ||
    (isFriday(currentDate) && currentDate < cutOffDate)
  )
}
